import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import LotsList from "./LotsList";

let routes = [
  {
    path: 'lots',
    name: 'lots',
    component: LotsList,
    meta: {
      requiresAuth: true
    }
  },
];

export default {
  menuItem: new MenuItem('/lots', i18n.t('Lots'), 30, 'boxes', [], 'view_auction'),
  routes: routes
}

